import { useContext } from 'react';
import { BrandInfoContext } from '@core-ui/brand-info-provider';
import { Brands } from '@core-ui/react-stitch';
import { useMobile } from '../hooks/mobile.hook';
import { useBRRedesign } from './br-redesign.hook';

export const useMarketingFlag = (): boolean => {
  const { abbrBrand } = useContext(BrandInfoContext);
  const isBRRedesign = useBRRedesign();

  return !(useMobile() && isBRRedesign && abbrBrand === Brands.BananaRepublic);
};
